import React from "react";

function Heading(props) {
  return (
    <>
      <div className="">
        <h2 className="inline px-3 py-1 text-3xl rounded-r-full font-simple bg-gradient-to-tr from-yellow-200 to-yellow-500">
          {props.heading}
        </h2>
      </div>
    </>
  );
}

export default Heading;
